import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  ModalProps,
  Row,
  notification,
} from 'antd'
import moment from 'moment'
import React, { ReactElement, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { updateOrder } from './tenantSlice'
import { unwrapResult } from '@reduxjs/toolkit'

interface OrderEditModalProps {
  record?: any
  params?: any
  onRefresh?: () => void
}

export const OrderEditModal = ({
  record,
  params,
  onRefresh,
  onCancel,
  ...others
}: OrderEditModalProps & ModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  useEffect(() => {
    if (record && others.visible) {
      form.setFieldsValue({
        amount: record.amount,
        remark: record.remark,
        serveEndTime: record.serveEndTime ? moment(record.serveEndTime) : undefined,
      })
    }
  }, [record, others.visible])

  const handleOk = () => {
    form.validateFields().then((values) => {
      dispatch(
        updateOrder({
          id: record.id,
          amount: values.amount,
          remark: values.remark,
          serveEndTime: values.serveEndTime
            ? moment(values.serveEndTime).format('YYYY-MM-DD HH:mm:ss')
            : undefined,
        })
      )
        .then(unwrapResult)
        .then(() => {
          notification.success({ message: '修改成功' })
          onRefresh && onRefresh()
          onCancel && onCancel(undefined as any)
        })
        .catch(() => {
          notification.error({ message: '修改失败' })
        })
    })
  }

  return (
    <Modal
      {...others}
      title='修改订单'
      width={500}
      onCancel={onCancel}
      footer={
        <>
          <Button onClick={onCancel}>取消</Button>
          <Button type='primary' onClick={handleOk}>
            确定
          </Button>
        </>
      }
    >
      <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
        <Row>
          <Col span={24}>
            <Form.Item label='订单号'>
              <Input value={record?.id} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label='实收金额' name='amount'>
              <InputNumber style={{ width: '100%' }} precision={2} min={0} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label='备注' name='remark'>
              <Input.TextArea rows={3} maxLength={150} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label='到期时间' name='serveEndTime'>
              <DatePicker showTime style={{ width: '100%' }} format='YYYY-MM-DD HH:mm:ss' />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}
